export const environment: any = {
  production: false,
  projectUrl: 'https://v2.prod.port1.somosclientportal.com/',
  supabaseUrl: 'https://api.v2.prod.port1.somosclientportal.com/',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgwNDE2OTY5LCJleHAiOjE5MzgwOTY5Njl9.E5kk-d2Uc4Rxlsj3fmtWiH0F_uYhaImG8Ow9owiG10c',
  lambdaUrl: 'https://lambda.v2.prod.port1.somosclientportal.com',
  turnstileSiteKey: '0x4AAAAAAFDU3QXwplceic7S',
};

